export default __webpack_public_path__ + "static/media/061-olive oil.bf516e7d.svg";